<div class="student-play-container pt-5">
    <div class="w-100 h-100 pt-5 d-flex flex-column align-items-center">
        <img class="mb-5" src="assets/icons/hands.svg" alt="">
        <h1 class="pt-5 text-24-600-112">{{'Join Your Team!' | translate}}</h1>
        <p class="text-18-400-144 text-c2">{{'Enter your team’s code to join' | translate}}</p>
        <div class="p-5 w-100 d-flex flex-column">
            <p class="text-14-500-157 text-c5">
                {{'Team code' | translate}}
                <span class="text-danger">*</span>
            </p>
            <input [(ngModel)]="teamCode" class="team-code-input text-16-400-150" type="text" [placeholder]="('Team Code' | translate)">
            <p *ngIf="loginError" class="text-danger text-14-500-157">{{loginError | translate}}</p>
            <p *ngIf="!groupIdExists" class="text-danger mb-0 text-14-500-157">{{'Group not found. Scan QR code again!' | translate}}</p>
            <button [ngClass]="{'p-none':teamCode.trim() == ''}" (click)="joinGame()" class="mt-5 verify-btn text-16-600-150">{{'Verify and Join' | translate}}</button>
        </div>
    </div>
</div>
